module.exports = {
    noPostFound: {
        en: "No post found.",
        fi: "Ei ilmoituksia."
    }
};